import React from 'react'
import MobileNavItem from './MobileNavItem';

const MobileNavItems = ({ menu, labels }) => {
	if (!menu || !menu.length) return;
	
	return (
		<ul className="nav-menu__list">
			{menu.map((item) => {
				return <MobileNavItem item={item} key={item.title} labels={labels} />
			})}
		</ul>
	)
}

export default MobileNavItems